module.exports = __webpack_public_path__ + "img/ia-05-2.d3a97959.jpg";